module.exports = __webpack_public_path__ + "static/img/M8.b818c5ed.png";